
import callAPI from '../fetch/main';


const createPaymentLink = (plan, default_currency, messageApi, loadingState, checkoutState, provider) => {

  messageApi.open({
    type: 'loading',
    content: 'Please wait',
    duration: 0,
    key: 'payment-process'
  });

  let apiURL = `create_subscription`
  let body = { "plan_price": plan, "default_currency": default_currency }

  if (default_currency === "usd") {
    body["provider"] = provider || "stripe"
  }

  callAPI({ url: apiURL, method: "POST", body: body, loadingState: loadingState, dataState: checkoutState })
}

export default createPaymentLink;